import React from 'react';
import Icon from '../AppIcon';

const MonthlyRankingItem = ({ entry, index, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center justify-between gap-3 p-3 rounded-md border border-border bg-muted/30 hover:bg-muted/50 transition-gaming"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div
          className={`w-8 h-8 rounded-full flex items-center justify-center ${
            index < 3 ? 'bg-primary/20 text-primary' : 'bg-muted text-muted-foreground'
          }`}
        >
          {index < 3 ? <Icon name="Crown" size={14} /> : <span className="text-xs font-semibold">{index + 1}</span>}
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-foreground truncate">{entry.username}</div>
          <div className="text-xs text-muted-foreground caption">{entry.proof_count}회 인증</div>
        </div>
      </div>
      <div className="flex items-center gap-3 flex-shrink-0">
        <span className="text-sm font-bold text-primary data-text">#{index + 1}</span>
        <div className="w-8 h-8 rounded-full bg-card border border-border overflow-hidden flex items-center justify-center">
          {entry.avatar_url ? (
            <img
              src={entry.avatar_url}
              alt={entry.username || 'avatar'}
              className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
            />
          ) : (
            <Icon name="User" size={14} className="text-muted-foreground" />
          )}
        </div>
      </div>
    </button>
  );
};

export default MonthlyRankingItem;
